import script from "./BacktestTradeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BacktestTradeTable.vue?vue&type=script&setup=true&lang=js"

import "./BacktestTradeTable.vue?vue&type=style&index=0&id=0cb1d6ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb1d6ae"]])

export default __exports__